import { useState } from "react"
import {MapPin, Menu, X} from 'lucide-react'

const navLinks = [
  { label: "Calculator", href: "#calculator" },
  { label: "Features", href: "#features" },
  { label: "FAQ", href: "#faq" },
]

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <nav className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50 no-print">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 bg-emerald-900 rounded-lg flex items-center justify-center group-hover:bg-emerald-800 transition-colors">
              <MapPin className="w-5 h-5 text-amber-300" />
            </div>
            <span
              className="text-lg font-bold text-gray-900 hidden sm:block"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              Land<span className="text-emerald-700">Mortgage</span>Calculator
            </span>
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-emerald-800 hover:bg-emerald-50 rounded-lg transition-all"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#calculator"
              className="ml-2 px-5 py-2.5 bg-emerald-800 text-white text-sm font-bold rounded-lg hover:bg-emerald-900 transition-colors shadow-sm"
            >
              Get Started
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden p-2 text-gray-600 hover:text-gray-900"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen ? (
          <div className="md:hidden py-4 border-t border-gray-100 animate-fade-in">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-emerald-50 hover:text-emerald-800 rounded-lg"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#calculator"
              onClick={() => setMobileOpen(false)}
              className="block mt-2 mx-4 px-5 py-3 bg-emerald-800 text-white text-sm font-bold rounded-lg text-center hover:bg-emerald-900 transition-colors"
            >
              Get Started
            </a>
          </div>
        ) : null}
      </div>
    </nav>
  )
}
